import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// our modules
import { setRentalPlanIndex as setRentalPlanIndexAction } from 'ggApp/modules/rentalPlan/actions';
import { registerProductDetailedImpression as registerProductDetailedImpressionAction } from 'ggApp/modules/gaAnalytics';
import { registerSubLengthEvent as registerSubLengthEventAction } from 'ggApp/modules/gaAnalytics/actions';

export const withProductRentalPlanHandler = compose(
    connect(null, (dispatch) =>
        bindActionCreators(
            {
                setRentalPlanIndex: setRentalPlanIndexAction,
                registerProductDetailedImpression: registerProductDetailedImpressionAction,
                registerSubLengthEvent: registerSubLengthEventAction,
            },
            dispatch,
        ),
    ),
    withHandlers({
        changeRentalPlan: (props) => (planIndex) => {
            const { setRentalPlanIndex, registerSubLengthEvent } = props;
            setRentalPlanIndex(planIndex);
            registerSubLengthEvent();
        },
    }),
);
